import type { CredentialVaultTab } from "@/features/credentials/components/credential-vault-view";
import type { WorkspaceProvider } from "../../workspace-types";
import { LegacyDocuments } from "./legacy-documents";
import { NativeDocuments } from "./native-documents";

/** The provider's credential record behind the Credentials and Documents
 * tabs: on the current model the vault, showing the view the page's tab
 * picks; on the legacy model its record, which lists files under each
 * credential. */
export function CredentialRecord({
  provider,
  organizationBusinessUnitId,
  view,
}: {
  provider: WorkspaceProvider;
  organizationBusinessUnitId: string;
  view: CredentialVaultTab;
}) {
  if (provider.credentialModel === "legacy") {
    return (
      <LegacyDocuments
        provider={provider}
        organizationBusinessUnitId={organizationBusinessUnitId}
      />
    );
  }
  return (
    <NativeDocuments
      provider={provider}
      organizationBusinessUnitId={organizationBusinessUnitId}
      view={view}
    />
  );
}
